export default __webpack_public_path__ + "static/sofiia-trokhymchuk-827e3c7b40fa602c7095cdf3385330bd.png";